import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './SkinType.module.sass';
import Button from '../../../ui_kit/button/Button';
import BackButton from '../../../quiz/components/back_button/BackButton';
import oilyIcon from '../../../../images/pages/regimen_finder/skin_types/oily.svg';
import dryIcon from '../../../../images/pages/regimen_finder/skin_types/dry.svg';
import normalToOilyIcon from '../../../../images/pages/regimen_finder/skin_types/normal-to-oily.svg';
import normalToDryIcon from '../../../../images/pages/regimen_finder/skin_types/normal-to-dry.svg';
import sensitiveIcon from '../../../../images/pages/regimen_finder/skin_types/sensitive.svg';
import normalIcon from '../../../../images/pages/regimen_finder/skin_types/normal.svg';
import Block from './block/Block';
import SKIN_TYPES from '../../constants/skin_types';

function SkinType(props) {
  const {
    increaseStep, decreaseStep, regimen, step,
  } = props;

  const [skinType, setSkinType] = useState(regimen.skinType);
  const [isSensitiveSkin, setIsSensitiveSkin] = useState(regimen.isSensitiveSkin);

  const onNextClick = () => {
    increaseStep({ ...regimen, skinType, isSensitiveSkin });
  };

  const onSkinTypeSelected = (selectedSkinType) => {
    setSkinType(selectedSkinType);
  };

  const onSensitiveSkinSelected = (selectedSensitiveSkin) => {
    setIsSensitiveSkin(selectedSensitiveSkin);
  };

  return (
    <div className={styles['skin-type']}>
      <div className={styles.content}>
        <BackButton
          decreaseStep={() => { decreaseStep({ ...regimen, skinType, isSensitiveSkin }); }}
        />
        {step}
        <div className={styles.title}>
          How would you describe your skin type?
        </div>
        <div className={styles['skin-types']}>
          <Block
            icon={oilyIcon}
            text={SKIN_TYPES.OILY}
            active={skinType === SKIN_TYPES.OILY}
            onClick={() => { onSkinTypeSelected(SKIN_TYPES.OILY); }}
          />
          <Block
            icon={dryIcon}
            text={SKIN_TYPES.DRY}
            active={skinType === SKIN_TYPES.DRY}
            onClick={() => { onSkinTypeSelected(SKIN_TYPES.DRY); }}
          />
          <Block
            icon={normalToOilyIcon}
            text={SKIN_TYPES.NORMAL_TO_OILY}
            active={skinType === SKIN_TYPES.NORMAL_TO_OILY}
            onClick={() => { onSkinTypeSelected(SKIN_TYPES.NORMAL_TO_OILY); }}
          />
          <Block
            icon={normalToDryIcon}
            text={SKIN_TYPES.NORMAL_TO_DRY}
            active={skinType === SKIN_TYPES.NORMAL_TO_DRY}
            onClick={() => { onSkinTypeSelected(SKIN_TYPES.NORMAL_TO_DRY); }}
          />
          <Block
            icon={normalIcon}
            text={SKIN_TYPES.NORMAL}
            active={skinType === SKIN_TYPES.NORMAL}
            onClick={() => { onSkinTypeSelected(SKIN_TYPES.NORMAL); }}
          />
        </div>
        <div className={`${styles.title}`}>
          Sensitive skin?
        </div>
        <div className={styles['sensitive-skin']}>
          <Block
            icon={sensitiveIcon}
            text={SKIN_TYPES.SENSITIVE}
            active={isSensitiveSkin}
            onClick={() => { onSensitiveSkinSelected(true); }}
          />
          <Block
            icon={normalIcon}
            text={SKIN_TYPES.NOT_SENSITIVE}
            active={isSensitiveSkin === false}
            onClick={() => { onSensitiveSkinSelected(false); }}
          />
        </div>
        <Button
          className={styles.button}
          onClickHandler={onNextClick}
          disabled={skinType === null || isSensitiveSkin === null}
          text="NEXT"
          color="green"
          size="small"
        />
      </div>
    </div>
  );
}

SkinType.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  regimen: PropTypes.shape({
    skinType: PropTypes.string,
    isSensitiveSkin: PropTypes.bool,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default SkinType;
